import React, {PropTypes} from 'react';
import cn from 'classnames';

import style from './style.scss';

class SurveyStart extends React.Component {

  render() {
    const {steps, current} = this.props;

    let stepDivs = [];
    steps.forEach((step, i) => {
      let selected = {};
      selected[style.selected] = i <= current - 1;

      if (i > 0) {
        stepDivs.push(
          <div className={cn(style.connector, selected)}
            key={`connector-${i}`}></div>
        );
      }
      stepDivs.push(
        <div className={cn(style.step, selected)} key={i}>
          <div className={style.label}>
            {step}
          </div>
          <div className={style.circle}>{i + 1}</div>
        </div>
      );
    })

    return (
      <div className={style.progress}>
        {stepDivs}
      </div>
    );
  }
};

SurveyStart.propTypes = {
  steps: PropTypes.array.isRequired,
  current: PropTypes.number.isRequired
};

export default SurveyStart;



/** WEBPACK FOOTER **
 ** ./src/app/components/survey/progress/index.jsx
 **/